import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from "../components/home/Home"
//CANADAS CASAS ROUTES
import CanadasCasas from '../components/canadas/casas/CanadasCasas';
import MenuCanadasCasas from '../components/canadas/casas/Menu';
import SubMenuCanadasCasas from '../components/canadas/casas/SubMenu';
import detailLocationCanadasCasas from '../components/canadas/casas/dataillocation/Main';
//CANADAS TERRENOS ROUTES
import CanadasTerrenos from '../components/canadas/terrenos/CanadasTerrenos';
import MenuCanadasTerrenos from '../components/canadas/terrenos/Menu';
import SubMenuCanadasTerrenos from '../components/canadas/terrenos/SubMenu';
import detailLocationCanadasTerrenos from '../components/canadas/terrenos/detailLocation/Main';
//CANADAS DEPTOS ROUTES
import CanadasDeptos from '../components/canadas/deptos/CanadasDeptos';
import MenuCanadasDeptos from '../components/canadas/deptos/Menu';
import SubMenuCanadasDeptos from '../components/canadas/deptos/SubMenu';
import pisoCanadasDeptos from '../components/canadas/deptos/PisoMenu';
import detailLocationCanadasDeptos from '../components/canadas/deptos/detailLocation/Main'
//TORRES PANORAMA ROUTES
import TorresPanorama from '../components/torrespanorama/TorresPanorama';
import MenuTorresPanorama from '../components/torrespanorama/Menu';
import SubMenuTorresPanorama from '../components/torrespanorama/SubMenu';
import pisoTorresPanorama from '../components/torrespanorama/PisoMenu';
import detailLocationTorresPanorama from '../components/torrespanorama/detailLocation/Main'
//PASEO DEL PARQUE ROUTES
import PaseoDelParque from '../components/paseodelparque/PaseoDelParque';
import MenuPaseoDelParque from '../components/paseodelparque/Menu';
import SubMenuPaseoDelParque from '../components/paseodelparque/SubMenu';
import etapaPaseoDelParque from '../components/paseodelparque/EtapaMenu';
import detailLocationPaseoDelParque from '../components/paseodelparque/detailLocation/Main'
//VALLE NORTE ROUTES
import ValleNorte from '../components/vallenorte/Vallenorte';
import MenuValleNorte from '../components/vallenorte/Menu';
import detailLocationValleNorte from '../components/vallenorte/detailLocation/Main'
//VALLE SUR ROUTESx
import ValleSur from '../components/vallesur/Vallesur';
import MenuValleSur from '../components/vallesur/Menu';
import detailLocationValleSur from '../components/vallesur/detailLocation/Main'
//ALAMOS ROUTES
import Alamos from '../components/alamos/Alamos';
import MenuAlamos from '../components/alamos/Menu';
import detailLocationALamos from '../components/alamos/detaillocation/Main'
//BOSQUES ROUTES
//Casas
import BosquesCasas from "../components/bosques/casas/BosquesCasas.vue";
import MenuBosquesCasas from "../components/bosques/casas/Menu.vue";
import detailLocationBosquesCasas from "../components/bosques/casas/detailLocation/Main.vue";
//Terrenos
import BosquesTerrenos from "../components/bosques/terrenos/BosquesTerrenos.vue";
import MenuBosquesTerrenos from "../components/bosques/terrenos/Menu.vue";
import detailLocationBosquesTerrenos from "../components/bosques/terrenos/detailLocation/Main.vue";
//Encinos ROUTES
import Encinos from '../components/encinos/Encinos';
import MenuEncinos from '../components/encinos/Menu';
import detailLocationEncinos from '../components/encinos/detailLocation/Main'
//SENDEROS ROUTES
import Senderos from '../components/senderos/Senderos';
import MenuSenderos from '../components/senderos/Menu';
import detailLocationSenderos from '../components/senderos/detaillocation/Main'
//LomAlta ROUTES
import LomALta from "../components/lomalta/LomALta";
import MenuLomAlta from '../components/lomalta/Menu';
import SubMenuLomAlta from '../components/lomalta/SubMenu';
import detailLocationLomAlta from '../components/lomalta/detailLocation/Main';
//CIUDAD SALUD ROUTES
import CiudadSalud from "../components/ciudadsalud/CiudadSalud";
import MenuCiudadSalud from '../components/ciudadsalud/Menu';
import SubMenuCiudadSalud from '../components/ciudadsalud/SubMenu';
import detailLocationCiudadSalud from '../components/ciudadsalud/detailLocation/Main';

//CIUDAD SALUD ROUTES
import ClubDeGolf from "../components/clubdegolf/ClubDeGolf";
import MenuClubDeGolf from '../components/clubdegolf/Menu';
import SubMenuClubDeGolf from '../components/clubdegolf/SubMenu.vue';
import Seccion from '../components/clubdegolf/SeccionMenu.vue';
//import detailLocationClubdeGolf from '../components/clubdegolf/detailLocation/Main';

//PRADO SUR ROUTES
import PradoSur from "../components/pradosur/Pradosur";
import MenuPradoSur from '../components/pradosur/Menu';
import SubMenuPradoSur from '../components/pradosur/SubMenu';
import detailLocationPradoSur from '../components/pradosur/detailLocation/Main';

//Aniversario club de golf routes
import AniversarioClubDeGolf from "../components/aniversarioclubdegolf/Menu"

/* Add pb rediseno routes -------------*/
//TORRE AIREA PLUS ROUTES PV-----
import TorreAirea from '../components/torreairea/TorreAireaPlus';
import MenuTorreAirea from '../components/torreairea/Menu';
import SubMenuTorreAirea from '../components/torreairea/SubMenu';

//torrespaseo ROUTES PV---
import TPP from '../components/torrespaseoparque/TPDP';
import MenuTPP from '../components/torrespaseoparque/Menu';
import SubMenuTPP from '../components/torrespaseoparque/SubMenu';
/* CANADS PB CASAS----- */
import CanadsCasas from '../components/canads/casas/CanadasCasas';
import MenuCanadsCasas from '../components/canads/casas/Menu';
import SubMenuCanadsCasas from '../components/canads/casas/SubMenu';
/* import detailLocationCanadsCasas from '../components/canads/casas/dataillocation/Main'; */
/* CANADS TERRENOS ROUTES----- */
import CanadsTerrenos from '../components/canads/terrenos/CanadasTerrenos';
import MenuCanadsTerrenos from '../components/canads/terrenos/Menu';
import SubMenuCanadsTerrenos from '../components/canads/terrenos/SubMenu';

/* Descomentar para mostrar detalles de zona comercial peñasco y prado sur */

//PEÑASCOS TERRENOS COMERCIALES ROUTES
import Zcpeniasco from "../components/zcpeniasco/Peniasco.vue";
import MenuZcpeniasco from "../components/zcpeniasco/Menu.vue";
import detailLocationZcpeniasco from "../components/zcpeniasco/detailLocation/Main";

//PRADO SUR TERRENOS COMERCIALES ROUTES
import ZcPradoSur from "../components/zcpradosur/PradoSur.vue";
import MenuZcPradoSur from "../components/zcpradosur/Menu.vue";
import detailLocationZcPradoSur from "../components/zcpradosur/detailLocation/Main";

/*
//TORRE VISTA HERMOSA-----
import TorreVistaHermosa from '../components/torrevistahermosa/TorreVistaHermosa.vue';
import MenuTorreVistaHermosa from '../components/torrevistahermosa/Menu.vue';
import SubMenuTorreVistaHermosa from "../components/torrevistahermosa/SubMenu";
*/

Vue.use(VueRouter)
const routes = [
  {
    path: "/",
    component: Home,
    meta: { title: "Planes Maestros Tres Marías" },
  },
  {
    path: "/canadas_casas",
    component: CanadasCasas,
    meta: { title: "Casas Cañadas" },
    children: [
      {
        path: "/",
        component: MenuCanadasCasas,
        meta: { title: "Casas Cañadas" },
      },
      {
        path: "/canadas_casas/cve_nivel_te=:id/nombre_nivel_te=:privada",
        component: SubMenuCanadasCasas,
        meta: { title: "Privada" },
        props: true,
      },
      {
        path: "/canadas_casas/cve_nivel_te=:id/nombre_nivel_te=:privada/detalles/:idLocation",
        component: detailLocationCanadasCasas,
        meta: { title: "Privada" },
      },
    ],
  },
  {
    path: "/canadas_terrenos",
    component: CanadasTerrenos,
    meta: { title: "Terrenos Cañadas" },
    children: [
      {
        path: "/",
        component: MenuCanadasTerrenos,
        meta: { title: "Terrenos Cañadas" },
      },
      {
        path: "/canadas_terrenos/cve_nivel_te=:id/nombre_nivel_te=:privada",
        component: SubMenuCanadasTerrenos,
        props: true,
        meta: { title: "Privada" },
      },
      {
        path: "/canadas_terrenos/cve_nivel_te=:id/nombre_nivel_te=:privada/detalles/:idLocation",
        component: detailLocationCanadasTerrenos,
        meta: { title: "Privada" },
      },
    ],
  },
  {
    path: "/canadas_deptos",
    component: CanadasDeptos,
    meta: { title: "Departamentos Cañadas" },
    children: [
      {
        path: "/",
        component: MenuCanadasDeptos,
        meta: { title: "Departamentos Cañadas" },
      },
      {
        path: "/canadas_deptos/nombre_torre_etapa=:torre/cve_torre_etapa=:id",
        component: SubMenuCanadasDeptos,
        props: true,
        meta: { title: "Nivel Departamento" },
      },
      {
        path: "/canadas_deptos/nombre_torre_etapa=:torre/cve_torre_etapa=:id/cve_nivel_te=:idPiso/nombre_nivel_te=:piso",
        component: pisoCanadasDeptos,
        meta: { title: "Nivel Departamento" },
      },
      {
        path: "/canadas_deptos/nombre_torre_etapa=:torre/cve_torre_etapa=:id/cve_nivel_te=:idPiso/nombre_nivel_te=:piso/detalles/:idLocation",
        component: detailLocationCanadasDeptos,
        meta: { title: "Nivel Departamento" },
      },
    ],
  },
  {
    path: "/torrespanorama",
    component: TorresPanorama,
    meta: { title: "Torres Panorama" },
    children: [
      {
        path: "/",
        component: MenuTorresPanorama,
        meta: { title: "Torres Panorama" },
      },
      {
        path: "/torrespanorama/nombre_torre_etapa=:torre/cve_torre_etapa=:id",
        component: SubMenuTorresPanorama,
        props: true,
        meta: { title: "Nivel Departamento" },
      },
      {
        path: "/torrespanorama/nombre_torre_etapa=:torre/cve_torre_etapa=:id/cve_nivel_te=:idPiso/nombre_nivel_te=:piso",
        component: pisoTorresPanorama,
        meta: { title: "Nivel Departamento" },
      },
      {
        path: "/torrespanorama/nombre_torre_etapa=:torre/cve_torre_etapa=:id/cve_nivel_te=:idPiso/nombre_nivel_te=:piso/detalles/:idLocation",
        component: detailLocationTorresPanorama,
        meta: { title: "Nivel Departamento" },
      },
    ],
  },
  {
    path: "/paseodelparque",
    component: PaseoDelParque,
    meta: { title: "Pase del Parque" },
    children: [
      {
        path: "/",
        component: MenuPaseoDelParque,
        meta: { title: "Pase del Parque" },
      },
      {
        path: "/paseodelparque/nombre_torre_etapa=:torre/cve_torre_etapa=:id",
        component: SubMenuPaseoDelParque,
        props: true,
        meta: { title: "Etapa" },
      },
      {
        path: "/paseodelparque/nombre_torre_etapa=:torre/cve_torre_etapa=:id/cve_nivel_te=:idPiso/nombre_nivel_te=:piso",
        component: etapaPaseoDelParque,
        meta: { title: "Etapa" },
      },
      {
        path: "/paseodelparque/nombre_torre_etapa=:torre/cve_torre_etapa=:id/cve_nivel_te=:idPiso/nombre_nivel_te=:piso/detalles/:idLocation",
        component: detailLocationPaseoDelParque,
        meta: { title: "Etapa" },
      },
    ],
  },
  {
    path: "/vallenorte",
    component: ValleNorte,
    meta: { title: "Valle norte" },
    children: [
      {
        path: "/",
        component: MenuValleNorte,
        meta: { title: "Valle norte" },
      },
      {
        path: "/vallenorte/detalles/:idLocation",
        component: detailLocationValleNorte,
        meta: { title: "Valle norte" },
      },
    ],
  },
  {
    path: "/vallesur",
    component: ValleSur,
    meta: { title: "Valle sur" },
    children: [
      {
        path: "/",
        component: MenuValleSur,
        meta: { title: "Valle sur" },
      },
      {
        path: "/vallesur/detalles/:idLocation",
        component: detailLocationValleSur,
        meta: { title: "Valle sur" },
      },
    ],
  },
  {
    path: "/alamos",
    component: Alamos,
    meta: { title: "Alamos" },
    children: [
      {
        path: "/",
        component: MenuAlamos,
        meta: { title: "Alamos" },
      },
      {
        path: "/alamos/detalles/:idLocation",
        component: detailLocationALamos,
        meta: { title: "Alamos" },
      },
    ],
  },
  {
    path: "/bosques_casas",
    component: BosquesCasas,
    meta: { title: "Casas Bosques" },
    children: [
      {
        path: "/",
        component: MenuBosquesCasas,
        meta: { title: "Casas Bosques" },
      },
      {
        path: "/bosques_casas/detalles/:idLocation",
        component: detailLocationBosquesCasas,
        meta: { title: "Casas Bosques" },
      },
    ],
  },
  {
    path: "/bosques_terrenos",
    component: BosquesTerrenos,
    meta: { title: "Terrenos Bosques" },
    children: [
      {
        path: "/",
        component: MenuBosquesTerrenos,
        meta: { title: "Terrenos Bosques" },
      },
      {
        path: "/bosques_terrenos/detalles/:idLocation",
        component: detailLocationBosquesTerrenos,
        meta: { title: "Terrenos Bosques" },
      },
    ],
  },
  {
    path: "/encinos",
    component: Encinos,
    meta: { title: "Encinos" },
    children: [
      {
        path: "/",
        component: MenuEncinos,
        meta: { title: "Encinos" },
      },
      {
        path: "/encinos/detalles/:idLocation",
        component: detailLocationEncinos,
        meta: { title: "Encinos" },
      },
    ],
  },
  {
    path: "/lomalta",
    component: LomALta,
    meta: { title: "Terrenos LomAlta" },
    children: [
      {
        path: "/",
        component: MenuLomAlta,
        meta: { title: "Terrenos LomAlta" },
      },
      {
        path: "/lomalta/cve_nivel_te=:id/nombre_nivel_te=:privada",
        component: SubMenuLomAlta,
        props: true,
        meta: { title: "Privada" },
      },
      {
        path: "/lomalta/cve_nivel_te=:id/nombre_nivel_te=:privada/detalles/:idLocation",
        component: detailLocationLomAlta,
        meta: { title: "Privada" },
      },
    ],
  },
  {
    path: "/ciudadsalud",
    component: CiudadSalud,
    meta: { title: "Zona Comercial Ciudad Salud" },
    children: [
      {
        path: "/",
        component: MenuCiudadSalud,
        meta: { title: "Zona Comercial Ciudad Salud" },
      },
      {
        path: "/ciudadsalud/cve_nivel_te=:id/nombre_nivel_te=:privada",
        component: SubMenuCiudadSalud,
        props: true,
        meta: { title: "Valle" },
      },
      {
        path: "/ciudadsalud/cve_nivel_te=:id/nombre_nivel_te=:privada/detalles/:idLocation",
        component: detailLocationCiudadSalud,
        meta: { title: "Valle" },
      },
    ],
  },
  {
    path: "/clubdegolf",
    component: ClubDeGolf,
    meta: { title: "Club de Golf" },
    children: [
      {
        path: "/",
        component: MenuClubDeGolf,
        meta: { title: "Club de Golf" },
      },
      {
        path: "/clubdegolf/preseccion/:idLocation",
        component: SubMenuClubDeGolf,
        props: true,
        meta: { title: "Club de Golf" },
      },
      {
        path: "/clubdegolf/preseccion/:seccion/cve_nivel_te=:id",
        component: Seccion,
        props: true,
        meta: { title: "Club de Golf" },
      },
      {
        path: "/clubdegolf/preseccion/detalles/:idLocation",
        component: detailLocationSenderos,
        meta: { title: "Club de Golf" },
      },
    ],
  },
  {
    path: "/senderos",
    component: Senderos,
    meta: { title: "Senderos" },
    children: [
      {
        path: "/",
        component: MenuSenderos,
        meta: { title: "Senderos" },
      },
      {
        path: "/senderos/detalles/:idLocation",
        component: detailLocationSenderos,
        meta: { title: "Senderos" },
      },
    ],
  },
  {
    path: "/aniversarioclubdegolf",
    component: AniversarioClubDeGolf,
  },
  {
    path: "/pradosur",
    component: PradoSur,
    meta: { title: "Terrenos PradoSur" },
    children: [
      {
        path: "/",
        component: MenuPradoSur,
        meta: { title: "Terrenos PradoSur" },
      },
      {
        path: "/pradosur/cve_nivel_te=:id/nombre_nivel_te=:privada",
        component: SubMenuPradoSur,
        props: true,
        meta: { title: "Privada" },
      },
      {
        path: "/pradosur/cve_nivel_te=:id/nombre_nivel_te=:privada/detalles/:idLocation",
        component: detailLocationPradoSur,
        meta: { title: "Privada" },
      },
    ],
  },
  {
    path: "/torreaireaplus",
    component: TorreAirea,
    meta: { title: "Torres Torre Airea Plus" },
    children: [
      {
        path: "/",
        component: MenuTorreAirea,
        meta: { title: "Torres Torre Airea Plus" },
      },
      {
        path: "/torreaireaplus/nombre_torre_etapa=:torre/cve_torre_etapa=:id",
        component: SubMenuTorreAirea,
        props: true,
        meta: { title: "Nivel Departamento" },
      },
    ],
  },
  {
    path: "/torrespaseodelparque",
    component: TPP,
    meta: { title: "Torres Paseo del Parque" },
    children: [
      {
        path: "/",
        component: MenuTPP,
        meta: { title: "Torres Paseo del Parque" },
      },
      {
        path: "/torrespaseodelparque/nombre_torre_etapa=:torre/cve_torre_etapa=:id",
        component: SubMenuTPP,
        props: true,
        meta: { title: "Nivel Departamento" },
      },
    ],
  },
  {
    path: "/canads_casas",
    component: CanadsCasas,
    meta: { title: "Casas Cañadas" },
    children: [
      {
        path: "/",
        component: MenuCanadsCasas,
        meta: { title: "Casas Cañadas" },
      },
      {
        path: "/canads_casas/cve_nivel_te=:id/nombre_nivel_te=:privada",
        component: SubMenuCanadsCasas,
        meta: { title: "Privada" },
        props: true,
      },
      /* {
                path: '/canadas_casas/cve_nivel_te=:id/nombre_nivel_te=:privada/detalles/:idLocation',
                component: detailLocationCanadsCasas,
                meta:{title:'Privada'},

            }, */
    ],
  },
  {
    path: "/canads_terrenos",
    component: CanadsTerrenos,
    meta: { title: "Terrenos Cañadas" },
    children: [
      {
        path: "/",
        component: MenuCanadsTerrenos,
        meta: { title: "Terrenos Cañadas" },
      },
      {
        path: "/canads_terrenos/cve_nivel_te=:id/nombre_nivel_te=:privada",
        component: SubMenuCanadsTerrenos,
        props: true,
        meta: { title: "Privada" },
      },
      /* {
                path: '/canadas_terrenos/cve_nivel_te=:id/nombre_nivel_te=:privada/detalles/:idLocation',
                component: detailLocationCanadasTerrenos,
                meta:{title:'Privada'},
            }, */
    ],
  },
  /*{
      path: '/mapa_detalle',
      component: MapDetail,
      name: 'detalle',
      props: true
    }*/
  /* Descomentar para mostrar detalles de zona comercial peñasco y prado sur */

  {
    path: "/zcpeniasco",
    component: Zcpeniasco,
    meta: { title: "Peñasco" },
    children: [
      {
        path: "/",
        component: MenuZcpeniasco,
        meta: { title: "Peñasco" },
      },
      {
        path: "/zcpeniasco/detalles/:idLocation",
        component: detailLocationZcpeniasco,
        meta: { title: "Peñasco" },
      },
    ],
  },
  {
    path: "/zcpradosur",
    component: ZcPradoSur,
    meta: { title: "Zona Comercial Prado Sur" },
    children: [
      {
        path: "/",
        component: MenuZcPradoSur,
        meta: { title: "Zona Comercial Prado Sur" },
      },
      {
        path: "/zcpradosur/detalles/:idLocation",
        component: detailLocationZcPradoSur,
        meta: { title: "Zona Comercial Prado Sur" },
      },
    ],
  },
/*
  {
    path: "/torrevistahermosa",
    component: TorreVistaHermosa,
    meta: { title: "Torre Vista Hermosa" },
    children: [
      {
        path: "/",
        component: MenuTorreVistaHermosa,
        meta: { title: "Torre Vista Hermosa" },
      },
      {
        path: "/torrevistahermosa/nombre_torre_etapa=:torre/cve_torre_etapa=:id",
        component: SubMenuTorreVistaHermosa,
        props: true,
        name: "torreDetalle",
      },
    ],
  },
  */
  // Ruta de no encontrado

  {
    path: "/:pathMatch(.*)*",
    redirect: "/",
  },
];
const router = new VueRouter({
    mode: 'history',
    scrollBehavior() {
      
            return {x: 0, y: 0}
     
    },
    base: process.env.BASE_URL,
    routes
})
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
      document.title = to.meta.title;
    }
    next();
  });
export default router
